/* Visit Furniture — lazy full navigation (v39).
   The server renders a lite header (department links only) so every page's
   HTML is ~300ms faster. After load, or as soon as the shopper touches the
   header, this fetches the full header section once, swaps in the dropdowns,
   the All-departments flyout and the drawer sub-panels, then binds them.
   The markup is cached in sessionStorage for 30 minutes so later pages swap
   instantly without another request. */
(function () {
  'use strict';
  var nav = document.querySelector('.header-depts[data-vf-nav="lite"]');
  var me = document.currentScript;
  if (!nav) return;
  var src = nav.getAttribute('data-vf-nav-src');
  var flyoutSrc = me && me.getAttribute('data-flyout-src');
  var themeId = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '';
  var KEY = 'vf-nav:' + themeId + ':' + src;
  var TTL = 30 * 60 * 1000;
  var started = false;
  var done = false;

  function readCache() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || Date.now() - obj.t > TTL) return null;
      return obj.h;
    } catch (e) { return null; }
  }
  function writeCache(html) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), h: html })); } catch (e) {}
  }

  function bindMega() {
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-mega-toggle]'));
    function panelFor(t) { return document.getElementById(t.getAttribute('aria-controls')); }
    function closeAll(except) {
      toggles.forEach(function (t) {
        if (t === except) return;
        var p = panelFor(t);
        t.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
    }
    toggles.forEach(function (t) {
      var panel = panelFor(t);
      if (!panel) return;
      t.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        var isOpen = t.getAttribute('aria-expanded') === 'true';
        closeAll(t);
        t.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && t.getAttribute('aria-expanded') === 'true') {
          var first = panel.querySelector('a');
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
    });
    if (!toggles.length) return;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = toggles.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
      if (open) { closeAll(); open.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header-depts') && !e.target.closest('.mega')) closeAll();
    });
    document.addEventListener('focusin', function (e) {
      if (!e.target.closest('.header-depts') && !e.target.closest('.mega')) closeAll();
    });
  }

  function bindDrilldown(drilldown) {
    if (!drilldown) return;
    var panels = Array.prototype.slice.call(drilldown.querySelectorAll('[data-panel]'));
    var byName = {};
    panels.forEach(function (p) { byName[p.getAttribute('data-panel')] = p; });
    var stack = [];
    function show(name, focusSel) {
      var next = byName[name];
      if (!next) return;
      panels.forEach(function (p) { var on = p === next; p.hidden = !on; p.classList.toggle('is-active', on); });
      drilldown.scrollTop = 0;
      if (focusSel) { var f = next.querySelector(focusSel); if (f) f.focus(); }
    }
    drilldown.addEventListener('click', function (e) {
      var push = e.target.closest('[data-drill-to]');
      if (push) {
        var cur = panels.filter(function (p) { return p.classList.contains('is-active'); })[0];
        if (cur) stack.push({ panel: cur.getAttribute('data-panel'), opener: push });
        show(push.getAttribute('data-drill-to'), '[data-drill-back]');
        return;
      }
      if (e.target.closest('[data-drill-back]')) {
        var prev = stack.pop();
        show(prev ? prev.panel : 'root');
        if (prev && prev.opener) prev.opener.focus();
      }
    });
    var dlg = drilldown.closest('dialog');
    if (dlg) dlg.addEventListener('close', function () { stack.length = 0; show('root'); });
  }

  function apply(html) {
    if (done) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshInner = doc.querySelector('.header-depts[data-vf-nav="full"] .header-depts__inner');
    var freshDrill = doc.querySelector('#nav-drawer [data-drilldown]');
    var curInner = nav.querySelector('.header-depts__inner');
    var curDrill = document.querySelector('#nav-drawer [data-drilldown]');
    if (!freshInner || !curInner) return false;
    done = true;
    curInner.replaceWith(document.importNode(freshInner, true));
    nav.setAttribute('data-vf-nav', 'full');
    if (freshDrill && curDrill) {
      var node = document.importNode(freshDrill, true);
      /* keep links vf-enhance added to the drawer's root panel */
      var help = curDrill.querySelector('.vf-drawer-help');
      var root = node.querySelector('[data-panel="root"]');
      if (help && root) root.appendChild(help);
      curDrill.replaceWith(node);
      bindDrilldown(node);
    }
    bindMega();
    if (flyoutSrc) {
      var s = document.createElement('script');
      s.src = flyoutSrc;
      document.head.appendChild(s);
    }
    document.dispatchEvent(new CustomEvent('vf:nav-full'));
    return true;
  }

  function go() {
    if (started) return;
    started = true;
    var cached = readCache();
    if (cached && apply(cached) !== false) return;
    var url = src;
    var preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { if (apply(html) !== false) writeCache(html); })
      .catch(function () { started = false; });
  }

  /* Interaction with the header: fetch right away. */
  var header = nav.closest('.shopify-section') || document;
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    header.addEventListener(ev, go, { once: true, passive: true });
  });
  var menuBtn = document.querySelector('.site-header__menu-toggle');
  if (menuBtn) menuBtn.addEventListener('pointerdown', go, { once: true, passive: true });

  /* Otherwise: shortly after the page has finished loading. */
  function idle() {
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
    else setTimeout(go, 200);
  }
  if (document.readyState === 'complete') setTimeout(idle, 1200);
  else window.addEventListener('load', function () { setTimeout(idle, 1200); }, { once: true });
})();
